export const FieldValidatorProps = {
  Validate: {
    type: Array,
    required: false,
    validator: (value) =>
      Array.isArray(value) &&
      value.length > 0 &&
      value.every(
        (v) => v && v.name && v.message && typeof v.validator === "function"
      )
  },
  Required: {
    type: Boolean,
    required: false,
  }
}

export const FieldValidatorAcknowledgeFG = function () {
  let $parent = this.$parent;
  let isParentFGFound = false;

  while ($parent) {
    if ($parent.$vnode && $parent.$vnode.componentOptions.tag === "ui-formgroup") {
      isParentFGFound = true;
      break;
    } else {
      $parent = $parent.$parent;
    }
  }

  if (isParentFGFound) {
    this.fg = $parent;
    this.fg.onChildInit(this);
  } else {
    throw new Error(
      `Error inside UI component ${this.name}. All UI components must be childed to a UI Formgroup component.`
    );
  }
}

export default {}
